
import { Grid, List, ListItem, ListItemText, Typography, Box, Paper } from "@mui/material"

import moment from "moment"

import { InfoField } from "./InfoField";

import { IrregularProps } from "../interfaces/recepcion/IrregularInterface";

interface Props {
    irregular?:        IrregularProps;
}

export const BoxInformacionIrregular = ( { irregular }: Props ) => {
    
    return (

        <Box p={4} component={ Paper }>

            <Grid container spacing={3}>  
 
                {
                    irregular?.numeroIrregular
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <InfoField
                                label="Número de irregular" 
                                value={ irregular?.numeroIrregular }
                                fontSize={ 16 }
                            />   
                            
                        </Grid>  
                }    
      
                {
                    irregular?.numeroExpediente
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <InfoField
                                label="Número de expediente" 
                                value={ irregular?.numeroExpediente }
                                fontSize={ 16 }
                            />   
                            
                        </Grid>  
                }    

                {
                    irregular?.fecha
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <InfoField
                                label="Fecha" 
                                value={ moment( new Date( irregular?.fecha ) ).format( 'DD-MM-YYYY' ) }
                                fontSize={ 16 }
                            />  
                            
                        </Grid>    
                }     
      

                 {
                    ( irregular?.etapa && irregular?.subEtapa )
                    ?
                        <Grid size={{ md: 6, xs: 12 }}>

                            <InfoField
                                label="Etapa" 
                                value={ `${ irregular?.etapa } (${ irregular?.subEtapa })` }
                                fontSize={ 16 }
                            />  

                        </Grid>  
                    :
                        irregular?.etapa
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>

                                <InfoField
                                    label="Etapa" 
                                    value={ irregular?.etapa }
                                    fontSize={ 16 }
                                />   
                                
                            </Grid>  
                }         

                {
                    irregular?.juez
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <InfoField
                                label="Juez" 
                                value={ irregular?.juez }
                                fontSize={ 16 }
                            />   
                            
                        </Grid>  
                }
                
                {
                    irregular?.secretario
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <InfoField
                                label="Secretario(a) admisibilidad" 
                                value={ irregular?.secretario }
                                fontSize={ 16 }
                            />   
                            
                        </Grid>  
                }
           
                {
                    irregular?.juzgadoOrigen
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <InfoField
                                label="Juzgado de origen" 
                                value={ irregular?.juzgadoOrigen }
                                fontSize={ 16 }
                            />   
                            
                        </Grid>  
                }   

                {
                    irregular?.actores.length !== 0
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>
                    
                            <List disablePadding>
                
                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    color: "text.secondary",
                                                    letterSpacing: 0.5,
                                                    fontWeight: 700,
                                                }}>
                                                    Actor(es):
                                            </Typography>
                                        }
                                        slotProps={{ secondary: { component: 'div' } }}
                                        secondary={
                                            <List disablePadding>

                                                {
                                                    irregular?.actores.map( ( actor, index) => (

                                                        <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                            <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'} fontSize={ 16 }>{ actor }</Typography>
                                                        </ListItem>

                                                    ))
                                                }                                         
                                                                                                        
                                            </List>                                           
                                        }
                                    />

                                </ListItem>

                            </List>
                        
                        </Grid>          
                }  
              
                {
                    irregular?.demandados.length !== 0
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>
                    
                            <List disablePadding>
                
                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={
                                            <Typography
                                                variant="subtitle2"
                                                sx={{
                                                    color: "text.secondary",
                                                    letterSpacing: 0.5,
                                                    fontWeight: 700,
                                                }}>
                                                    Demandado(s):
                                            </Typography>
                                        }
                                        slotProps={{ secondary: { component: 'div' } }}
                                        secondary={
                                            <List disablePadding>

                                                {
                                                    irregular?.demandados.map( ( demandado, index) => (

                                                        <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                            <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'} fontSize={ 16 }>{ demandado }</Typography>
                                                        </ListItem>

                                                    ))
                                                }                                         
                                                                                                        
                                            </List>                                           
                                        }
                                    />

                                </ListItem>

                            </List>
                        
                        </Grid>          
                } 

                 {
                    irregular?.digitalizacion
                    &&
                        <Grid size={{ md: 12, xs: 12 }}>

                            <List disablePadding>
                
                                <ListItem sx={{ py: 0, px: 0 }}>

                                    <ListItemText
                                        sx={{ mr: 2 }}
                                        primary={ 
                                            <Typography  
                                                variant="subtitle2"
                                                sx={{
                                                    color: "text.secondary",
                                                    letterSpacing: 0.5,
                                                    fontWeight: 700,
                                                }}> 
                                                    Digitalización: 
                                            </Typography> 
                                        }               
                                    />

                                </ListItem>

                            </List>
                
                            <iframe 
                                title='iframe-documento'
                                style={{ width: '100%', height: 800, borderRadius: 8 }}
                                src={ irregular?.digitalizacion ?? '' }
                            />

                        </Grid>                     
                }

            </Grid>      

        </Box>
    )
}
